import { Grid, Typography, Tab, Tabs, Box } from "@mui/material";
import React, { useState } from "react";
import { DashboardElement, DashboardIcon } from "./DashboardBuilder";
import uniqid from "uniqid";

function a11yProps(containerId, index) {
  return {
    id: `${containerId}-tab-${index}`,
    "aria-controls": `${containerId}-tabpanel-${index}`
  };
}

function TabPanel(props) {
  const { containerId, children, value, index, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`${containerId}-tabpanel-${index}`}
      aria-labelledby={`${containerId}-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

export default function DashboardTabContainer({ label, tabs, eventName }) {
  const containerId = uniqid();
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = async (e, newTab) => {
    setActiveTab(newTab);
  };

  return (
    <Box>
      {label?.length ? (
        <Typography
          variant="h5"
          sx={{
            mb: 3,
            color: "primary",
            fontWeight: 600,
            textAlign: "center",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            pt: 2
          }}
        >
          {label}
        </Typography>
      ) : (
        <></>
      )}
      <Box
        sx={{
          mb: 2,
          borderBottom: 1,
          borderColor: "divider"
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          aria-label={`${label} tabs`}
          allowScrollButtonsMobile
          textColor="secondary"
          indicatorColor="secondary"
          sx={{ width: "100%" }}
        >
          {tabs?.map((tab, i) => {
            let tabProps = {};
            if (tab.label) {
              tabProps.label = tab.label;
            }
            if (tab.icon) {
              const Icon = DashboardIcon(tab.icon);
              tabProps.icon = <Icon />;
            }
            return (
              <Tab
                {...tabProps}
                {...a11yProps(containerId, i)}
                sx={{ whiteSpace: "nowrap", flex: 1 }}
              />
            );
          })}
        </Tabs>
      </Box>
      {tabs?.map((tab, i) => (
        <TabPanel
          key={`tabpanel-${i}`}
          value={activeTab}
          container={containerId}
          index={i}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sx={{
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                boxShadow: 1,
                backgroundColor: "background.secondary"
              }}
            >
              <DashboardElement {...tab} eventName={eventName} />
            </Grid>
          </Grid>
        </TabPanel>
      ))}
    </Box>
  );
}
